var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#E2E2E2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 5842,
    transform: "translate(-825 -1970)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -37,
    width: 565,
    height: 474,
    rx: 8,
    fill: "#FBFFFE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.2364,
    cy: 41.7294,
    r: 41.3938,
    fill: "#D7FFF8",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.9234 31.4606C56.5047 31.4606 56.1031 31.6269 55.807 31.923C55.5109 32.2191 55.3446 32.6207 55.3446 33.0394V48.8274C55.3446 50.0836 54.8456 51.2883 53.9573 52.1766C53.0691 53.0648 51.8644 53.5638 50.6082 53.5638H34.8202C34.4014 53.5638 33.9999 53.7302 33.7038 54.0263C33.4077 54.3223 33.2414 54.7239 33.2414 55.1426C33.2414 55.5614 33.4077 55.9629 33.7038 56.259C33.9999 56.5551 34.4014 56.7214 34.8202 56.7214H50.6082C52.7018 56.7214 54.7097 55.8898 56.1901 54.4093C57.6705 52.9289 58.5022 50.9211 58.5022 48.8274V33.0394C58.5022 32.6207 58.3359 32.2191 58.0398 31.923C57.7437 31.6269 57.3421 31.4606 56.9234 31.4606ZM52.187 45.6698V29.8818C52.187 28.6256 51.688 27.4209 50.7997 26.5326C49.9115 25.6444 48.7068 25.1454 47.4506 25.1454H31.6626C30.4064 25.1454 29.2017 25.6444 28.3134 26.5326C27.4252 27.4209 26.9261 28.6256 26.9261 29.8818V45.6698C26.9261 46.926 27.4252 48.1307 28.3134 49.019C29.2017 49.9072 30.4064 50.4062 31.6626 50.4062H47.4506C48.7068 50.4062 49.9115 49.9072 50.7997 49.019C51.688 48.1307 52.187 46.926 52.187 45.6698ZM39.5566 28.303H42.7142V35.976L42.1458 35.5023C41.8621 35.266 41.5046 35.1366 41.1354 35.1366C40.7662 35.1366 40.4086 35.266 40.1249 35.5023L39.5566 35.976V28.303ZM30.0838 45.6698V29.8818C30.0838 29.4631 30.2501 29.0615 30.5462 28.7654C30.8423 28.4693 31.2438 28.303 31.6626 28.303H36.399V39.3546C36.3989 39.6564 36.4854 39.9519 36.6482 40.2061C36.8109 40.4603 37.0431 40.6624 37.3173 40.7887C37.5914 40.915 37.896 40.96 38.1949 40.9185C38.4939 40.877 38.7746 40.7507 39.004 40.5545L41.1354 38.7705L43.2668 40.5545C43.5527 40.7991 43.9167 40.9334 44.293 40.9334C44.5214 40.9318 44.7471 40.8834 44.9561 40.7913C45.2301 40.6645 45.4621 40.4617 45.6244 40.2071C45.7867 39.9524 45.8725 39.6566 45.8718 39.3546V28.303H47.4506C47.8693 28.303 48.2709 28.4693 48.567 28.7654C48.8631 29.0615 49.0294 29.4631 49.0294 29.8818V45.6698C49.0294 46.0886 48.8631 46.4901 48.567 46.7862C48.2709 47.0823 47.8693 47.2486 47.4506 47.2486H31.6626C31.2438 47.2486 30.8423 47.0823 30.5462 46.7862C30.2501 46.4901 30.0838 46.0886 30.0838 45.6698Z",
    fill: "#0FAA8E"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -55,
    y: -58,
    width: 615,
    height: 524,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 5842,
    fill: "white",
    transform: "translate(-825 -1970)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.8859,
    height: 37.8859,
    fill: "white",
    transform: "translate(23.2935 22.7865)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEBook);
export default __webpack_public_path__ + "static/media/e-book.1bac72e5a10b3753bba9d4bd1d76c500.svg";
export { ForwardRef as ReactComponent };